import { TipoResponsavelModel } from "@/models/commons/ResponsavelModel";

export interface ITelefoneModel {
  id?: number;
  idTelefone?: number;
  
  ddd?:string;
  nome?:string;
  numero?: string;
  ramal?: string;
  email?: string;

  tipo?: TipoTelefoneModel;
  tipoResponsavel?: TipoResponsavelModel;
}

export interface TipoTelefoneModel {
  nome?: string;
  descricao?: string;
}

export const tiposTelefoneList: TipoTelefoneModel[] = [
  { nome: "CELULAR", descricao: "Celular" },
  { nome: "COMERCIAL", descricao: "Comercial" },
  { nome: "RESIDENCIAL", descricao: "Residencial" },
];
